import React, { useEffect, useState } from "react";
import moment from "moment";

import './Notificaciones.css';

import clienteAxios from "../../config/axios";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faExternalLinkAlt, faTrash } from "@fortawesome/free-solid-svg-icons";

const Notificaciones = () => {

    const [notificaciones, setNotificaciones] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelado = false;

        const fetchNotificaciones = async () => {
            try {
                const res = await clienteAxios.get('/notificacionPush');
                if (!cancelado) setNotificaciones(res.data?.data || []);
            } catch (error) {
                console.log("Error fetching notificaciones:", error.message);
            } finally {
                if (!cancelado) setLoading(false);
            }
        };

        fetchNotificaciones();

        return () => {
            cancelado = true;
            // Marcar todas como leidas al salir de la vista (igual que en mobile)
            clienteAxios.put('/notificacionPush/visto').catch(err =>
                console.log("Error marking notificaciones as read:", err.message)
            );
        };
    }, []);

    const borrarNotificaciones = async () => {
        try {
            await clienteAxios.delete('/notificacionPush/all');
            setNotificaciones([]);
        } catch (error) {
            console.log("Error deleting notificaciones:", error.message);
        }
    };

    const handleOpenLink = (url) => {
        if (!url) return;
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
        <div className="notificacionesView">
            <div className="notificacionesCard">
                <div className="notificacionesHeader">
                    <FontAwesomeIcon icon={faBell} />
                    <h3>Notificaciones</h3>
                </div>

                <div className="notificacionesContent">
                    {loading ? (
                    <p className="emptyState">Cargando...</p>
                ) : notificaciones.length === 0 ? (
                    <p className="emptyState">No tenés notificaciones por el momento.</p>
                ) : (
                    <ul className="notificacionesList">
                        {notificaciones.map((n) => (
                            <li key={n._id} className={`notificacionItem${n.visto ? ' leida' : ''}`}>
                                <div className="notificacionItemHeader">
                                    <span className="notificacionItemTitle">{n.title}</span>
                                    <span className="notificacionItemFecha">
                                        {moment.utc(n.fechaAlta).utcOffset(-3).format("DD/MM HH:mm")}
                                    </span>
                                </div>
                                <p className="notificacionItemBody">{n.body}</p>
                                {n.linkLabel && n.linkUrl && (
                                    <button
                                        type="button"
                                        className="notificacionItemLink"
                                        onClick={() => handleOpenLink(n.linkUrl)}
                                    >
                                        <FontAwesomeIcon icon={faExternalLinkAlt} />
                                        <span>{n.linkLabel}</span>
                                    </button>
                                )}
                            </li>
                        ))}
                    </ul>
                )}
                </div>
            </div>

            {notificaciones.length > 0 && (
                <button
                    type="button"
                    className="notificacionesDeleteAll"
                    onClick={borrarNotificaciones}
                >
                    <FontAwesomeIcon icon={faTrash} />
                    <span>Borrar todas</span>
                </button>
            )}
        </div>
    );
};

export default Notificaciones;
